import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=046e1966"
import script from "./echart.vue?vue&type=script&lang=js"
export * from "./echart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports